export enum LocationType {
    ROOT = 'ROOT',
    BRANCH = 'BRANCH',
    LEAF = 'LEAF',
    SECTION = 'SECTION',
}

export default class Location {
    constructor(readonly id: number, readonly key: string, readonly name: string, readonly type: LocationType) {}
}

export class LocationLinkCSV {
    constructor(readonly name: string, readonly linkedUrl: string, readonly type: LocationType) {}
}
